import Form from "./Form";
import FormHandler from "./FormHandler";

jQuery(() => {
    for (let key in window.MHP_Forms) {
        let form = Form.fromObject({
            key: key,
            conditions: window.MHP_Forms[key]
        })

        FormHandler.makeFromForm(form).forEach(handler => handler.init())
    }
})
